import { render, staticRenderFns } from "./BlockingRuleTableButton.vue?vue&type=template&id=061f5608&"
import script from "./BlockingRuleTableButton.vue?vue&type=script&lang=js&"
export * from "./BlockingRuleTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports